import { usePageTracking } from "@/hooks/usePageTracking";

export const PageTracker = () => {
  usePageTracking();
  return null;
};
